// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"public","806":"user","884":"admin","933":"auth","983":"products"}[chunkId] || chunkId) + "." + {"297":"28ad6749","624":"f178c147","806":"80e94369","884":"0ca9dfe7","933":"693f1163","983":"b26d847b"}[chunkId] + ".js";
};